module.exports = __webpack_public_path__ + "img/truck-02.b0d9edd6.svg";